const getSectorTotals = (data, sectorId, subSectorIds) => {
  return summarize(data.filter(datum => subSectorIds.has(datum.sector)), [
    "area",
    "indicator",
    "method",
    "year"
  ]).map(datum => ({
    ...datum,
    sector: sectorId
  }));
};

const getSubset = (obj, keys) =>
  keys.reduce((result, key) => {
    result[key] = obj[key];

    return result;
  }, {});

export const addSectorTotals = data => {
  const publicSectorTotals = getSectorTotals(data, 6, new Set([1, 2]));
  const privateSectorTotals = getSectorTotals(data, 3, new Set([4, 5]));

  return [...data, ...publicSectorTotals, ...privateSectorTotals];
};

export const calculateMix = (data, ofKey, byKey, totalName) => {
  const totals = data
    .filter(datum => datum[ofKey] === totalName)
    .reduce((result, datum) => {
      result[datum[byKey]] = datum.value;

      return result;
    }, {});

  return data.map(datum => ({
    ...datum,
    value: datum.value / totals[datum[byKey]]
  }));
};

export const differentiate = points => [
  points[0],
  ...points.slice(1).map((point, i) => ({
    y: point.y - points[i].y,
    users: point.users - points[i].users
  }))
];

export const filterByYear = (data, year) =>
  data.filter(
    datum => datum.year === year || typeof datum.year === "undefined"
  );

export const normalize = (values, total = 1) => {
  const sum = values.reduce((result, value) => result + value, 0);

  return values.map(value => (value / sum) * total);
};

export const orderByValues = (data, values, key) => {
  const valueIndices = values.reduce((result, value, index) => {
    result[value] = index;

    return result;
  }, {});

  return data.sort((a, b) => valueIndices[a[key]] - valueIndices[b[key]]);
};

export const summarize = (data, keys) =>
  Object.values(
    data.reduce((result, datum) => {
      const summaryKey = keys.map(key => datum[key]).join("|");

      if (!result[summaryKey]) {
        result[summaryKey] = {
          ...getSubset(datum, keys),
          value: 0
        };
      }

      result[summaryKey].value += datum.value;

      return result;
    }, {})
  );
